import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="content">
      <div className="card">
        <h2 className="section-title">Page not found</h2>
        <p className="help-text">The page you are looking for doesn’t exist.</p>
        <Link to="/dashboard" className="btn btn-primary">
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
}

